import React from "react";
import { OutputArea } from "./OutputArea";

interface ReadModeProps {
    message: string | null;
    isLoading: boolean;
}

const ReadMode: React.FC<ReadModeProps> = ({ message, isLoading }) => {
    return (
        <div className="container mx-auto p-4">
            {isLoading ? (
                <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
                    <span className="ml-3">Generating Output...</span>
                </div>
            ) : (
                <OutputArea message={message} />
            )}
        </div>
    );
};

export default ReadMode;